import { percentToAbs } from '../../utils/fmtUtils'
import { colorPartido } from '../../utils'

export const option = (partido, nomenclator, horizontal) => {
	const absValue = percentToAbs(partido.pvot);
	const color = colorPartido(nomenclator, partido.codpar)
	return horizontal ? getHorizontalBar(absValue, color) : getVerticalBar(absValue, color);
}

const getHorizontalBar = (absValue, color) => {
	return {
		grid: {
			left: '1%',
			right: '1%',
		},
		xAxis: {
			show: false,
			type: 'value',
			max: 100,
			width: '100%'
		},
		yAxis: {
			show: false,
			type: 'category',
		},
		series: [
			{
				data: [{
					value: absValue,
					itemStyle:{
						color: color
					}
				}],
				type: 'bar',
				showBackground: true,
				backgroundStyle: {
					color: '#F8F8F7'
				},
				barHeight: '100%'
			}
		]
	}
}

const getVerticalBar = (absValue, color) => {
	return {
		grid: {
			top: '1%',
			bottom: '1%',
		},
		xAxis: {
			show: false,
			type: 'category',
			width: '150px'
		},
		yAxis: {
			show: false,
			type: 'value',
			max: 100,
		},
		itemStyle:{
			color: color
		},
		series: [
			{
				data: [{
					value: absValue,
				}],
				type: 'bar',
				showBackground: true,
				backgroundStyle: {
					color: '#F8F8F7'
				},
				barWidth: '100%'
			}
		]
	}
}